import React, { useMemo } from 'react';
import { cssVars } from '@/app/styles';
import { getLicenseStatus } from '@/utils/data-utils';
import styled from 'styled-components';
import { License } from '../../license/license-types';

const STRStatus = styled.div`
  text-transform: uppercase;
  font-size: 15px;
  font-family: League Spartan;
`;

const LicenseStatusSection = styled.div`
  text-transform: uppercase;
  font-size: 18px;
`;

const StatusSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  margin-bottom: 16px;
`;

const LicenseStatus = styled.span<{ licensed: boolean }>`
  color: ${({ licensed }) =>
    licensed
      ? cssVars.color.statusColors.submitted.fg
      : cssVars.color.statusColors.denied.fg};
`;

export interface Props {
  licenseId: number | null;
  strLicense: string | null;
  shortTermRental: unknown;
  licenses: License[];
}

export const PropertyLicenseStatus = ({
  licenseId,
  strLicense,
  shortTermRental,
  licenses,
}: Props) => {
  const licenseStatus = useMemo(() => {
    return getLicenseStatus(licenseId, licenses);
  }, [licenseId, licenses]);

  const isLicensed = Boolean(strLicense);

  return (
    <StatusSection>
      <STRStatus>{shortTermRental && 'Short-Term Rental'}</STRStatus>
      <LicenseStatusSection>
        <LicenseStatus licensed={isLicensed}>
          {isLicensed ? licenseStatus : 'Unlicensed'}
        </LicenseStatus>{' '}
        {isLicensed && `(${strLicense})`}
      </LicenseStatusSection>
    </StatusSection>
  );
};
